export default __webpack_public_path__ + "static/media/wda_bridge_closeup.d6a299bd.jpeg";